import React from "react";
import { firestore } from '../firebase.js';
import { Link } from 'react-router-dom';
import '../Styles/Sass/UserListingCard.scss';

function UserListingCard(props) {
  const [userProfile, setUserProfile] = React.useState({});

  React.useEffect(() => {
    getUserData();
  }, [props.user]);

  const getUserData = () => {
    firestore.collection('users').doc(props.user).get()
      .then(res => {
        let userData = res.data();
        setUserProfile(userData);
      })
      .catch(err => {
        console.log(err);
      })
  }

  return (
    <Link className='userListingCard' to={`/cleanerprofile/${props.user}`}>
      <h4 className='userListingCard__name'>{userProfile.name}</h4>
      <h5 className='userListingCard__headline'>{userProfile.headline}</h5>
      <p className='userListingCard__description'>{userProfile.description}</p>
      <div className='userListingCard__subBox'>
        <p className='userListingCard__rate'>${userProfile.rate} per hour</p>
        <p className='userListingCard__location'>
          {userProfile.city} | {userProfile.postal} | {userProfile.province}
        </p>
      </div>
    </Link>
  );
}

export default UserListingCard;